module.exports = __webpack_public_path__ + "static/media/bank_100_02.7cb75cee.png";